
@switch (subType) {
  @case (layoutSubType.SEARCH) {
    <lm-form-content-search #LMFormSearchComponent
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      [listUrlInfo]="listUrlInfo"
      (fieldEvent)="onFieldEvent($event)"
      (customizeButtonClicked)="onCustomizeClicked($event)"
      (searchButtonClicked)="onSearchClicked($event)"
      (clearSearchButtonClicked)="onClearSearchClicked($event)"
    ></lm-form-content-search>
  }
  @case (layoutSubType.PAGE_CONTEXT) {
    <lm-form-content-form #LMPageContextComponent
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      [isInOverlay]="inFormOverlay"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-form>
  }
  @case (layoutSubType.STANDARD) {
    <lm-form-content-form #LMFormStandardComponent
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [parentIsModal]="parentIsModal"
      [formPersonalization]="formPersonalization"
      [isInOverlay]="inFormOverlay"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-form>
  }
  @case (layoutSubType.COMPOSITE) {
    <lm-form-content-composite #LMComposite
      [model]="model"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [specFields]="specFields"
      [formOptions]="formOptions"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [parentIsModal]="parentIsModal"
      [isInOverlay]="inFormOverlay"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (sendShortcutMessage)="onSendShortcutMessage($event)"
      (specialActionsToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
      (panelTransactionEvent)="onPanelTransactionEvent($event)"
      (drillAroundEvent)="onDrillAroundEvent($event)"
    ></lm-form-content-composite>
  }
  @case (layoutSubType.STEP_PROCESS_OR_WIZARD) {
    <lm-form-content-stepprocess #LMStepProcessComponent
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
      (stepPanelEvent)="onStepPanelEvent($event)"
      (contentModified)="onContentModified($event)"
      (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
      (sendContextMessageEvent)="onSendContextMessageEvent($event)"
      (specialActionToolbarButtonEvent)="onSpecialActionToolbarButtonEvent($event)"
      (panelTransactionEvent)="onPanelTransactionEvent($event)"
      (drillAroundEvent)="onDrillAroundEvent($event)"
    ></lm-form-content-stepprocess>
  }
  @case (layoutSubType.INSTANCE_COUNT_CHART) {
    <lm-form-content-instancechart #LMInstanceChart
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [fromDataView]="fromDataView"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-instancechart>
  }
  @case (layoutSubType.MANUAL_REPRESENTATION) {
    <lm-form-content-manual-representation #LMManualRepresentation
      [formSpec]="formSpec"
      [model]="model"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [formPersonalization]="formPersonalization"
      [fromDataView]="fromDataView"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
    ></lm-form-content-manual-representation>
  }
  @case (layoutSubType.MENU_LAYOUT) {
    <lm-form-content-menu #LMMenu
      [layout]="layout"
      [specFields]="specFields"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [model]="model"
      [formState]="formState"
      [placeHolder]="placeHolder"
      [formPersonalization]="formPersonalization"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-form-content-menu>
  }
  @case (layoutSubType.MATRIX) {
    <lm-form-content-matrix #LMMatrix
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [specFields]="specFields"
      [formOptions]="formOptions"
      [placeHolder]="placeHolder"
      [formState]="formState"
      [model]="model"
      [matrixFormSpec]="formSpec.busFormSpec"
      [matrixView]="fromDataView"
      (matrixActionEvent)="onRunMatrixActionEvent($event)"
      (fieldEvent)="onFieldEvent($event)"
      (contentModified)="onContentModified($event)"
    ></lm-form-content-matrix>
  }
}

<lm-report-field-picker-drawer [canShowDrawer]="canShowReportFieldPickerDrawer"></lm-report-field-picker-drawer>
